import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { NgxPermissionsModule } from 'ngx-permissions';
import { EnvironmentConfig } from './config/environment.config';
import { ENVIRONMENT_CONFIG } from './config/environment.config.token';
import { CoreModule } from './modules/core/core.module';
import { ErrorInterceptor } from './modules/core/interceptor/error.interceptor';
import { JwtInterceptor } from './modules/core/interceptor/jwt.interceptor';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false,
  maxScrollbarLength: 100,
  wheelSpeed: 1,
};

// export function createTranslateLoader(http: HttpClient): any {
//   return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
// }
@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    PerfectScrollbarModule,
    OAuthModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    TranslateModule,
    CoreModule,
  ],
  exports: [
    TranslateModule
  ],
  providers: [
    { provide: OAuthStorage, useValue: localStorage },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
})
export class MedDataCommonModule {
  static forRoot(
    env: EnvironmentConfig
  ): ModuleWithProviders<MedDataCommonModule> {
    return {
      ngModule: MedDataCommonModule,
      providers: [
        {
          provide: ENVIRONMENT_CONFIG,
          useValue: env,
          multi: false,
        },
      ],
    };
  }
}
